import React, { useRef, useEffect, useState, useMemo } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import BackToConsole from "../BackToConsole/BackToConsole";
import StyledDivider from "../StyledDivider/StyledDivider";
import UserListing from "../UserListing/UserListing";
import axios from "axios";
import { uriConfig } from '../../data/uri';
import PopSnackBar from "../PopSnackBar/PopSnackBar";
import { useAuth0 } from '@auth0/auth0-react';
import Skeleton from '@mui/material/Skeleton';
import AddUserButton from "../AddUserButton/AddUserButton";
// import QlikLicencesChart from "../QlikLicencesChart/QlikLicencesChart";
import Auth0Groups from "../Auth0Groups/Auth0Groups";

const UserManagement = (props) => {
    const { authToken, organisationId, organisationName, allowedLicences, cardData, ...others } = props;
    const { user } = useAuth0();
    const snackRef = useRef();
    const auth0GroupsRef = useRef();
    const [userList, setUserList] = useState([]);
    const [userListLoading, setUserListLoading] = useState([true]);
    const [newUserMessage, setNewUserMessage] = useState(null);

    const fetchUsers = () => {
        const url = uriConfig.url.getUsers;
        setUserListLoading(true)
        axios.get(url, { params: { 'user_sub': user.sub }, headers: { 'auth-authorization': 'Bearer ' + authToken } })
            .then(function (response) {
                // handle success
                snackRef.current.snackBarOpen({ 'message': "Users loaded" })
                const newUserList = []
                for (let item of response.data) {
                    let userInfo = {
                        "FullName": item.fullname,
                        "IsDeleted": item.isdeleted,
                        "user_sub": item.sub,
                        "Email": item.email,
                        "metaData": item.type,
                        "InvitedStatus": item.invitedstatus,
                        // "QlikLicence": item.qliklicencetype
                    }
                    newUserList.push(userInfo)
                }
                setUserList(newUserList)
                setUserListLoading(false)
            }).catch(function (error) {
                // handle error
                snackRef.current.snackBarOpen({ 'message': error })
                setUserListLoading(false)
                console.log(error);
            });
    };


    //When we fetch users we also want to get the amount of licences they have bought

    // Get the current amount of licences used on their Qlik tenant
    // const currentLicenceInUse = userList.reduce((acc,user) => {
    //     const licenceType = user.QlikLicence;
    //     acc[licenceType] = (acc[licenceType] || 0) +1;
    //     return acc;
    // },{});
    const currentLicenceInUse = useMemo(() => {
        return userList.reduce((acc, user) => {
            const licenceType = user.QlikLicence;
            if (licenceType) {
                acc[licenceType] = (acc[licenceType] || 0) + 1;
            }
            return acc;
        }, {});
    }, [userList]);

    // console.log("allowedLicences", allowedLicences);
    // console.log("currentLicenceInUse", currentLicenceInUse);

    const deleteUser = (userSub) => {
        const url = uriConfig.url.postDeleteUser;
        let data = { 'user_sub': userSub };
        // Remove user's licence by setting it to "capacity"
        // Find the user's email from the userList
        // const userToEdit = userList.find(u => u.user_sub === userSub);
        // if (userToEdit) {
        //     EditUserLicence(userSub, userToEdit.Email, "capacity");
        // }
        axios.post(url, data, { headers: { 'auth-authorization': 'Bearer ' + authToken }, params: { 'user_sub': userSub } })
            .then(function (response) {
                // handle success
                fetchUsers()
                auth0GroupsRef.current?.fetchGroupMemberships()
                snackRef.current.snackBarOpen({ 'message': response.data })
                console.log("deletedUser" + userSub)
            }).catch(function (error) {
                // handle error
                snackRef.current.snackBarOpen({ 'message': error })
                console.log(error);
            });
    };

    const resendInvitation = (userEmail, userFullName) => {
        const url = uriConfig.url.postResendInviteUser;
        const data = {
            "invited_email": userEmail,
            "invited_fullname": userFullName,
            "organisation_name": organisationName,
            "organisation_id": organisationId,
        };

        axios.post(url, data, { headers: { 'auth-authorization': 'Bearer ' + authToken } })
            .then(function (response) {
                fetchUsers();
                auth0GroupsRef.current?.fetchGroupMemberships();
                snackRef.current.snackBarOpen({ 'message': `Invitation resent to ${userEmail}` });
            })
            .catch(function (error) {
                let message = "Failed to resend invitation";
                if (error.response?.data?.message) {
                    message = error.response.data.message;
                }
                snackRef.current.snackBarOpen({ 'message': message });
                console.log(error);
            });
    };

    const handleUserDeleted = () => {
        fetchUsers();
        auth0GroupsRef.current?.fetchGroupMemberships();
    };

    const handleUserAdded = () => {
        fetchUsers();
        auth0GroupsRef.current?.fetchGroupMemberships();
    };

    // const EditUserLicence = (userSub, userEmail, qlikLicence) => {
    //     const url = uriConfig.url.postEditLicence;
    //     let data = { 'user_sub': userSub, 'user_email': userEmail, 'qlikLicence': qlikLicence, 'currentLicenceInUse': currentLicenceInUse, 'allowedLicences': allowedLicences } // want to pass in user email? or anything else?
    //     axios.post(url, data, { headers: { 'auth-authorization': 'Bearer ' + authToken } })
    //         .then(function (response) {
    //             // handle success
    //             fetchUsers()
    //             snackRef.current.snackBarOpen({ 'message': response.data.message })
    //             setNewUserMessage(response.data.message)
    //         }).catch(function (error) {
    //             // handle error
    //             snackRef.current.snackBarOpen({ 'message': error })
    //             let message = "eefefef error";

    //             if (error.response?.status === 411) {
    //                 message = error.response.data.message || "Licence limit reached.";
    //             } else if (error.response?.status === 409) {
    //                 message = "User " + " already exists";
    //             } else if (error.response?.data?.message) {
    //                 message = error.response.data.message;
    //             }
    //             setNewUserMessage("User has been edited")
    //             console.log(error);
    //         });
    // };


    useEffect(() => {
        fetchUsers();
    }, []);

    // useEffect(() => {
    //     // once userList is rendered, log our licences being used
    //     console.log(currentLicenceInUse)
    // }, [userList]);

    // useEffect(() => {
    //     // updateDialog(dialogConfig)
    //     console.log("newusermessage"+newUserMessage)
    // },
    //     [newUserMessage])

    return (
        <>
            <Toolbar />
            <Box ml='90px' >
                <Box sx={{
                    marginTop: '5vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    <Typography variant='body1' color="text.secondary" marginBottom={'20px'}>
                        <strong>User Management</strong>
                    </Typography>
                    <Box sx={{
                        width: '80%'
                    }}>
                        <section id="go-back">
                            <BackToConsole linkLocation="/managementconsole" />
                        </section>
                        {/* REMOVED 18/09/2025 as no longer using professional and analyser model */}
                        {/* <section>
                            <QlikLicencesChart allowedLicences={allowedLicences} currentLicenceInUse={currentLicenceInUse}></QlikLicencesChart> 
                        </section> */}
                        <section id="add-user">
                            <Box sx={{ textAlign: 'right' }}>
                                <AddUserButton authToken={authToken} organisationId={organisationId} organisationName={organisationName} currentLicenceInUse={currentLicenceInUse} allowedLicences={allowedLicences} onUserAdded={handleUserAdded} cardData={cardData} />
                            </Box>
                        </section>
                        <section id='Current Users'>
                            <StyledDivider margin label='Current Users' />
                            <Box sx={{
                                textAlign: 'right'
                            }}>
                            </Box>
                            {userListLoading ? <>
                                <Skeleton variant="rectangular" height={100} animation="wave" sx={{ marginBottom: '5px' }} />
                                <Skeleton variant="rectangular" height={100} animation="wave" />
                            </> :
                                <UserListing
                                    list={userList}
                                    authToken={authToken}
                                    showDeletedUsers={false}
                                    btnFunc={deleteUser}
                                    resendInviteFunc={resendInvitation}
                                    onUserDeleted={handleUserDeleted}
                                    currentUserSub={user.sub}
                                />}
                        </section>
                        {/* <section id='Deleted Users' style={{ marginTop: '20px' }}>
                            <StyledDivider margin label='Deleted Users' />
                            <Box sx={{
                                textAlign: 'right'
                            }}>
                            </Box>
                            {userListLoading ? <>
                                <Skeleton variant="rectangular" height={100} animation="wave" sx={{ marginBottom: '5px' }} />
                                <Skeleton variant="rectangular" height={100} animation="wave" />
                            </> :
                                <UserListing list={userList} authToken={authToken} showDeletedUsers={true} noIcon={true} />}
                        </section> */}
                        <section id='Qlik Groups' style={{ marginTop: '20px' }}>
                            <StyledDivider margin label='Qlik Groups' />
                            <Box sx={{
                                textAlign: 'right'
                            }}>
                            </Box>
                                <Auth0Groups
                                    ref={auth0GroupsRef}
                                    authToken={authToken}
                                    userList={userList}
                                    onError={(error) => snackRef.current?.snackBarOpen({ 'message': error.message || error })}
                                />
                        </section>
                        <Box>
                        </Box>
                    </Box>
                </Box>
            </Box >
            <PopSnackBar ref={snackRef} />
        </>
    );
}

export default UserManagement;